import payWithSavedCard from "./pay_with_saved_card";
import updateCard from "./update_card";

/* eslint-disable no-inner-declarations */
function cardForm() {
  const $form = $(".js-stripe-form");
  if ($form.length) {
    const stripe = window.Stripe($form.attr("data-stripe-publishable-key"));

    let currentClientSecret = stripeIntentClientSecret();
    if (!currentClientSecret) {
      return;
    }

    let elements = null;
    let paymentElement = null;
    let billingAddressElement = null;

    const paymentElementOptions = {
      layout: "tabs",
      paymentMethodOrder: ["card"],
      terms: {
        card: "never",
      },
    };

    initialiseElements(currentClientSecret);
    observeClientSecretChanges();

    // Submit form
    const submitButton = document.querySelector(".js-stripe-submit");
    const form = document.getElementById("payment-form");

    if (form) {
      $(form).on("submit", async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (await userDetailsValid()) {
          await submitStripeForm();
        }
      });
    }

    function initialiseElements(clientSecret) {
      if (paymentElement) {
        paymentElement.destroy();
      }

      if (billingAddressElement) {
        billingAddressElement.destroy();
      }

      elements = stripe.elements({
        clientSecret: clientSecret,
        fonts: [
          {
            cssSrc: "https://fonts.googleapis.com/css?family=Roboto:400",
          },
        ],
      });

      paymentElement = elements.create("payment", paymentElementOptions);
      billingAddressElement = elements.create("address", {
        mode: "billing",
      });

      paymentElement.mount("#payment-element");
      billingAddressElement.mount("#billing-address-element");

      paymentElement.on("change", (event) => {
        setFieldError(
          "#payment-element-field-errors",
          event.error && event.error.message
        );
      });

      billingAddressElement.on("change", (event) => {
        setFieldError(
          "#billing-address-field-errors",
          event.error && event.error.message
        );
      });
    }

    function observeClientSecretChanges() {
      const intentSecretElement = document.querySelector(
        ".js-stripe-intent-secret"
      );
      if (!intentSecretElement) {
        return;
      }

      const observer = new MutationObserver(() => {
        const nextClientSecret = stripeIntentClientSecret();
        if (nextClientSecret && nextClientSecret !== currentClientSecret) {
          currentClientSecret = nextClientSecret;
          initialiseElements(nextClientSecret);
          setFieldError("#payment-element-field-errors", null);
          setFieldError("#billing-address-field-errors", null);
        }
      });

      observer.observe(intentSecretElement, {
        attributes: true,
        attributeFilter: ["value"],
      });
    }

    async function submitStripeForm() {
      window.disableModal();
      setSubmitLoadingState(true);

      const submitResult = await elements.submit();
      if (submitResult.error) {
        addErrors(submitResult.error.message);
        window.enableModal();
        return;
      }

      const addressResult = await billingAddressElement.getValue();
      if (!addressResult.complete) {
        setFieldError(
          "#billing-address-field-errors",
          "Please complete your billing address"
        );
        setSubmitLoadingState(false);
        window.enableModal();
        return;
      }

      const confirmationResult = await stripe.confirmPayment({
        elements: elements,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: (addressResult.value || {}).name || undefined,
              email: $(".js-buyer-email").val(),
              address: normalisedAddress((addressResult.value || {}).address),
            },
            metadata: {
              buyer_first_name: $(".js-buyer-first-name").val(),
              buyer_last_name: $(".js-buyer-last-name").val(),
              buyer_email: $(".js-buyer-email").val(),
            },
          },
        },
        redirect: "if_required",
      });

      if (confirmationResult.error) {
        addErrors(confirmationResult.error.message);
        window.enableModal();
        return;
      }

      let paymentIntent = confirmationResult.paymentIntent;
      if (!paymentIntent) {
        const retrieveResult = await stripe.retrievePaymentIntent(
          stripeIntentClientSecret()
        );
        paymentIntent = retrieveResult.paymentIntent;
      }

      if (
        paymentIntent &&
        ["succeeded", "processing", "requires_capture"].includes(
          paymentIntent.status
        )
      ) {
        $(".js-stripe-intent-id").val(paymentIntent.id);
        // Remove event to prevent a loop
        $(form).off("submit");
        //eslint-disable-next-line
        if (form.dataset.remote === "true") {
          Rails.fire(form, "submit"); // Rails UJS AJAX
        } else {
          (form as HTMLFormElement).submit(); // Native browser form submission
        }
      } else {
        addErrors("We could not verify the payment status. Please try again.");
        window.enableModal();
      }
    }

    function normalisedAddress(address) {
      const addressData = address || {};
      return {
        line1: addressData.line1 || undefined,
        line2: addressData.line2 || undefined,
        city: addressData.city || undefined,
        state: addressData.state || undefined,
        postal_code:
          addressData.postal_code || addressData.postalCode || undefined,
        country: addressData.country || undefined,
      };
    }

    function stripeIntentClientSecret() {
      return $(".js-stripe-intent-secret").val();
    }

    function addErrors(message = null) {
      const errors = $("#card-errors");

      errors
        .addClass("form-error-field")
        .addClass("card-error-message")
        .empty()
        .append(
          message ||
            "We’re sorry but your payment was unsuccessful, please check your card details or contact your bank"
        );

      setSubmitLoadingState(false);

      // If survey input is on checkout, it needs to shift up
      //  to avoid overlap with error message box.
      const survey_input = $("#survey-input");
      if (survey_input) {
        survey_input.addClass(
          "bm-checkout__survey--position-above-payment-errors"
        );
      }
    }

    function setSubmitLoadingState(isLoading) {
      if (!submitButton) {
        return;
      }

      if (isLoading) {
        submitButton.setAttribute("disabled", "disabled");
        submitButton.setAttribute("value", "Please wait, payment in progress");
      } else {
        submitButton.removeAttribute("disabled");
        submitButton.setAttribute(
          "value",
          $(submitButton).attr("data-original-title")
        );
      }
    }

    function setFieldError(selector, message) {
      const $displayError = $(selector);
      if (message) {
        $displayError.text(message);
      } else {
        $displayError.empty();
      }
    }

    async function billingAddressIsValid() {
      const addressResult = await billingAddressElement.getValue();

      if (addressResult.complete) {
        setFieldError("#billing-address-field-errors", null);
        return true;
      }

      setFieldError(
        "#billing-address-field-errors",
        "Please complete your billing address"
      );
      return false;
    }

    async function userDetailsValid() {
      window.setupPaymentValidation($form);

      const addressIsValid = await billingAddressIsValid();

      if (!$form.find(".is-invalid").length && addressIsValid) {
        return true;
      } else {
        return false;
      }
    }
  }

  payWithSavedCard();

  updateCard();
}

export default function setupCardForm() {
  cardForm();
}
